import { useAuth } from '../contexts/AuthContext';
import CompanyProfileForm from '../components/company/CompanyProfileForm';

export default function PendingApproval() {
  const { profile, signOut } = useAuth();

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(160deg, #F8FAFC 0%, #EEF2FF 50%, #F8FAFC 100%)' }}>
      <div className="max-w-2xl mx-auto px-6 py-16">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center mx-auto mb-4">
            <span className="text-white font-bold text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>PV</span>
          </div>
          <h1 className="text-3xl font-bold text-vault-navy mb-2" style={{ fontFamily: 'EB Garamond, Georgia, serif' }}>
            Account Under Review
          </h1>
          <p className="text-gray-500 text-sm max-w-md mx-auto">
            Welcome, {profile?.display_name}. Your company account is pending approval.
            While you wait, please complete your company profile below so our team can review your application.
          </p>
        </div>

        {/* Status banner */}
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-5 mb-8 text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <span className="w-2.5 h-2.5 rounded-full bg-amber-500 animate-pulse" />
            <span className="text-amber-700 font-semibold text-sm">Pending Approval</span>
          </div>
          <p className="text-amber-600 text-sm">
            You'll receive an email once your account has been approved. This usually takes 1-2 business days.
          </p>
        </div>

        {/* Company profile form */}
        <CompanyProfileForm />

        {/* Sign out */}
        <div className="text-center mt-8">
          <button
            onClick={signOut}
            className="text-sm text-gray-400 hover:text-gray-600 transition-colors"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
